export default __webpack_public_path__ + "static/vos-carmarion-90c1409f1a44cf55978e72ceee1d6825.mp4";